// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__v9m3i","inputWrap":"styles_inputWrap__2bp7d","input":"styles_input__6dj_E"};